var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#F2F4F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.55 12.505L19.495 10.45C19.2268 10.1981 18.8753 10.0535 18.5075 10.0439C18.1396 10.0342 17.7811 10.16 17.5 10.3975L10.75 17.1475C10.5076 17.392 10.3566 17.7124 10.3225 18.055L9.99998 21.1825C9.98988 21.2924 10.0041 21.4031 10.0417 21.5068C10.0793 21.6105 10.1393 21.7047 10.2175 21.7825C10.2876 21.852 10.3707 21.907 10.462 21.9443C10.5534 21.9817 10.6513 22.0006 10.75 22H10.8175L13.945 21.715C14.2876 21.6809 14.608 21.5299 14.8525 21.2875L21.6025 14.5375C21.8645 14.2607 22.0061 13.8914 21.9962 13.5104C21.9864 13.1294 21.8259 12.7679 21.55 12.505ZM13.81 20.215L11.56 20.425L11.7625 18.175L16 13.99L18.025 16.015L13.81 20.215ZM19 15.01L16.99 13L18.4525 11.5L20.5 13.5475L19 15.01Z",
    fill: "#202A3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/editButton.4c409026.svg";
export { ForwardRef as ReactComponent };